var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSponsorsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6555 33.1666C31.9455 32.9041 33.1637 32.3966 34.167 31.6441C36.9619 29.5966 36.9619 26.2191 34.167 24.1716C33.1816 23.4366 31.9813 22.9466 30.7093 22.6666",
    stroke: "#E3B027",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25172 23.6459C0.916094 26.4809 0.916094 31.1009 5.25172 33.9184C10.1786 37.1384 18.2586 37.1384 23.1854 33.9184C27.5211 31.0834 27.5211 26.4634 23.1854 23.6459C18.2765 20.4434 10.1965 20.4434 5.25172 23.6459Z",
    stroke: "#E3B027",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1977 5.16589C30.6734 5.16589 33.4683 7.91339 33.4683 11.2909C33.4683 14.5984 30.7809 17.2934 27.4307 17.4159C27.2873 17.3984 27.1261 17.3984 26.9648 17.4159",
    stroke: "#E3B027",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2093 17.1891C14.0302 17.1716 13.8152 17.1716 13.6181 17.1891C9.35417 17.0491 5.96808 13.6366 5.96808 9.43663C5.96808 5.14913 9.51541 1.66663 13.9227 1.66663C18.3121 1.66663 21.8773 5.14913 21.8773 9.43663C21.8594 13.6366 18.4733 17.0491 14.2093 17.1891Z",
    stroke: "#E3B027",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorsIcon);
export default __webpack_public_path__ + "static/media/sponsors_icon.d00221e50faca621cd01cd54163c01cd.svg";
export { ForwardRef as ReactComponent };